import { PortalMessage } from '@components/portalMessage/PortalMessage';
import { PortalMessageType } from '@components/portalMessage/PortalMessageType.enum';
import Loading from '@components/Loading';
import { Button } from '@components/button';
import { QuoteGetResponse } from '@lio/api-types';
import { Box, Typography } from '@mui/material';
import { useGetScreenSize } from '@utils/useGetScreenSize';
import { useLogoutHook } from '@hooks/useLogoutHook';

export const CustomerSubmissionMessage = ({ quote }: { quote: QuoteGetResponse }) => {
  const { isMobileScreen } = useGetScreenSize();
  const { handleLogout } = useLogoutHook();

  if (!quote) {
    return <Loading />;
  }

  return (
    <PortalMessage
      type={PortalMessageType.CustomerSubmission}
      title={['Thank you for choosing the Swim Club Insurance Program']}
      subtitle={[
        <Box component='div' key='main-text' sx={{ maxWidth: 400 }}>
          As for next steps:
        </Box>,
        <Box key='thanks' component='span' sx={{ display: 'flex', flexDirection: 'column' }}>
          A member of the SmithBrothers team will be in touch soon regarding the status of your insurance quote. Upon
          your convenience, please send your currently valued insurance company claims history reports (i.e. loss runs)
          for your property, general liability and other insurance coverage lines to the email address below.
        </Box>,
        <Box key='thanks' component='span' sx={{ display: 'flex', flexDirection: 'column' }}>
          For any questions, please contact:
        </Box>,
        <Box key='contact-info'>
          <Typography fontWeight='normal'>
            <b>Ashley Dick</b>, Program Manager
          </Typography>
          <Typography fontWeight='normal'>
            <b>p:</b> 1-800-426-6946
          </Typography>
          <Typography fontWeight='normal' sx={{ mb: 4 }}>
            <b>e:</b>{' '}
            <Button href='mailto:swimclubsins@smithbrothersusa.com' sx={{ margin: 0, padding: 0 }} variant='text'>
              swimclubsins@smithbrothersusa.com
            </Button>
          </Typography>
        </Box>,
        <Button fullWidth={isMobileScreen} key='logout' variant='contained' onClick={handleLogout}>
          Log Out
        </Button>,
      ]}
      quote={quote}
      sxProps={{
        leftSide: { width: '450px' },
      }}
    />
  );
};
